import { render, staticRenderFns } from "./version_edit.vue?vue&type=template&id=3f6ddd10&scoped=true"
import script from "./version_edit.vue?vue&type=script&lang=js"
export * from "./version_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ddd10",
  null
  
)

export default component.exports